import React from 'react';
import MagicReportWizard from '../components/monitoring-reports/magic-report/MagicReportWizard';

const MagicReportWizardPage = () => {
  return <MagicReportWizard />;
};

export default MagicReportWizardPage;
